<template>
	<div id="partners" class="bg-primary text-light">
		<b-container class="pb-5 text-center">
			<div v-for="partnerGroup in partnerGroups" :key="partnerGroup.title">
				<h2 class="py-5 m-0">{{partnerGroup.title}}</h2>
				<b-row cols="3" cols-md="5" class="align-items-center justify-content-center g-3">
					<b-col v-for="partner in partnerGroup.partners" :key="partner.url">
						<b-link :href="partner.href" target="_blank">
							<b-img
								fluid-grow
								:src="`/assets/images/logos/scaled/${partner.src}`"
								:alt="partner.alt"
								style="aspect-ratio: 1; object-fit: contain;"
							/>
						</b-link>
					</b-col>
				</b-row>
			</div>
		</b-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				partnerGroups: [
					{
						title: 'Current Nonprofit Partners',
						partners: [
							{
								alt: 'United Way of Windham County',
								href: 'https://www.unitedwaywindham.org',
								src: 'united-way-of-windham-county.png'
							},
							{
								alt: 'Sandglass Theater',
								href: 'https://www.sandglasstheater.org',
								src: 'sandglass-theater.png'
							},
							{
								alt: 'Food Connects',
								href: 'https://www.foodconnects.org',
								src: 'food-connects.png'
							},
							{
								alt: 'New England Youth Theatre',
								href: 'https://www.neyt.org',
								src: 'new-england-youth-theatre.png'
							},
							{
								alt: 'Vermont Jazz Center',
								href: 'https://vtjazz.org',
								src: 'vermont-jazz-center.png'
							},
							{
								alt: 'Rich Earth Institute',
								href: 'https://richearthinstitute.org',
								src: 'rich-earth-institute.png'
							},
							{
								alt: 'HatchSpace',
								href: 'https://www.hatchspace.org',
								src: 'hatchspace.png'
							},
							{
								alt: 'Windham County Dental Center',
								href: 'https://windhamcounty.dental',
								src: 'windham-county-dental-center.png'
							},
							{
								alt: 'Theatre Adventure',
								href: 'https://www.theatreadventure.org',
								src: 'theatre-adventure.png'
							},
							{
								alt: 'Boys & Girls Club of Brattleboro',
								href: 'https://bgcbrattleboro.org',
								src: 'boys-and-girls-club-of-brattleboro.png'
							},
							{
								alt: 'rePlay Arts',
								href: 'https://replayarts.org',
								src: 'replay-arts.png'
							},
							{
								alt: 'Chelsea Restoration Corporation',
								href: 'https://www.chelsearestoration.org',
								src: 'chelsea-restoration-corporation.png'
							},
							{
								alt: 'Bonnyvale Environmental Education Center',
								href: 'https://beec.org',
								src: 'bonnyvale-environmental-education-center.png'
							},
							{
								alt: 'Turning Point of Windham County',
								href: 'https://turningpointwc.org',
								src: 'turning-point-of-windham-county.png'
							},
							{
								alt: 'Ethiopian Community Development Council Vermont',
								href: 'https://ecdcvt.org',
								src: 'ethiopian-community-development-council-vermont.png'
							},
							{
								alt: `Newport Children's Theatre`,
								href: 'https://www.newportchildrenstheatre.org',
								src: 'newport-childrens-theatre.png'
							}
						]
					},
					{
						title: 'Past Nonprofit Partners',
						partners: [
							{
								alt: 'In-Sight Photography Project',
								href: 'https://www.insightphotography.org',
								src: 'in-sight-photography-project.png'
							},
							{
								alt: 'The Warrior Connection',
								href: 'https://www.warriorconnection.org',
								src: 'the-warrior-connection.png'
							},
							{
								alt: 'Downtown Brattleboro Alliance',
								href: 'https://www.brattleboro.com',
								src: 'downtown-brattleboro-alliance.png'
							},
							{
								alt: 'KidsPLAYce',
								href: 'https://kidsplaycevt.org',
								src: 'kidsplayce.png'
							},
							{
								alt: 'Brattleboro Music Center',
								href: 'https://bmcvt.org',
								src: 'brattleboro-music-center.png'
							},
							{
								alt: 'Groundworks Collaborative',
								href: 'https://groundworksvt.org',
								src: 'groundworks-collaborative.png'
							},
							{
								alt: 'The Commons',
								href: 'https://commonsnews.org',
								src: 'the-commons.svg'
							},
							{
								alt: 'League of NH Craftsmen',
								href: 'https://nhcrafts.org',
								src: 'league-of-nh-craftsmen.svg'
							},
							{
								alt: 'Vermont Center for Photography',
								href: 'https://vcphoto.org',
								src: 'vermont-center-for-photography.png'
							}
						]
					},
					{
						title: 'Past Training Partners',
						partners: [
							{
								alt: 'ECO AmeriCorps Vermont',
								href: 'https://dec.vermont.gov/administration-innovation/eco-americorps',
								src: 'eco-americorps-vermont.png'
							},
							{
								alt: 'Vermont Housing and Conservation Board',
								href: 'https://vhcb.org',
								src: 'vermont-housing-and-conservation-board.svg'
							},
							{
								alt: 'Brattleboro Development Credit Corporation',
								href: 'https://brattleborodevelopment.com',
								src: 'brattleboro-development-credit-corporation.svg'
							},
							{
								alt: 'Grrrls to the Front',
								href: 'https://stonechurchvt.com/gttf',
								src: 'grrrls-to-the-front.png'
							}
						]
					}
				]
			};
		}
	};
</script>
